/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { ALERT_EMAIL_CONFIG_COLLECTION_TOKEN } from 'ajs/modules/alert';

import {
    EmailValidationModalComponent,
} from 'ng/modules/email-validation-modal/email-validation-modal.component';

import * as globalL10n from 'global-l10n';
import * as l10n from './EmailController.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

angular.module('aviApp').controller('EmailController', [
'$scope', 'Collection', 'Regex', 'CRUDGridConfig', 'fullModalService', 'l10nService',
ALERT_EMAIL_CONFIG_COLLECTION_TOKEN,

function($scope, Collection, Regex, CRUDGridConfig, fullModalService, l10nService,
AlertEmailConfigCollection) {
    $scope.l10nKeys = l10nKeys;

    l10nService.registerSourceBundles(dictionary);

    $scope.gridConfig = new CRUDGridConfig();

    /**
     * Collection is doing all the job related to communication to server and data organization
     * @type {Collection}
     */
    $scope.collection = new AlertEmailConfigCollection();

    /**
     * Configures CollectionGrid directive, works in conjunction with Collection instance
     * instantiated above
     */
    $scope.gridConfig.collection = $scope.collection;

    $scope.gridConfig.fields = [{
        name: 'data.config.name',
        title: l10nService.getMessage(globalL10nKeys.nameLabel),
        sortBy: 'name',
    }, {
        name: 'data.config.to_emails',
        title: l10nService.getMessage(l10nKeys.columnTitleToAddress),
    }, {
        name: 'data.config.cc_emails',
        title: l10nService.getMessage(l10nKeys.columnTitleCCAddress),
    }];

    $scope.gridConfig.singleactions.unshift({
        title: l10nService.getMessage(l10nKeys.columnTitleValidateSettings),
        class: 'icon-lostlog',
        do(row) {
            const { config } = row.data;

            fullModalService.addModal({
                component: EmailValidationModalComponent,
                componentProps: {
                    uuid: row.data.config.uuid,
                    emailModalType: 'email',
                    config: {
                        to_emails: config.to_emails,
                        cc_emails: config.cc_emails,
                    },
                    onCancel: () => {
                        fullModalService.removeModalByComponent(
                            EmailValidationModalComponent,
                        );
                    },
                },
                getName: () => l10nService.getMessage(l10nKeys.emailTitleLabel),
                getDescription: () => '',
            });
        },
    });

    $scope.Regex = Regex;
}]);
